<template>
  <div class="template-page">
    <Sidebar/>

    <div class="app-body">
      <main class="main">

          <div v-if="profileWarning">
              <div class="alert alert-warning" role="alert">
                <div class="d-flex justify-content-between">
                  <div>{{profileWarning}}</div>
                  <router-link v-if="needConsent" to="/profile" class=" link">Complete now</router-link>
                </div>
              </div>
          </div>

        <router-view/>
      </main>
    </div>

  </div>
</template>

<script>

import nav from '../nav'
import Header from '@/components/parts/Header'
import Footer from '@/components/parts/Footer'
import Sidebar from '@/components/parts/Sidebar'
// import { mapState } from 'vuex'
import userProfile from '@/mixins/userProfile'

export default {
  name: 'Page',
  mixins: [userProfile],
  components: {
    Header,
    Footer,
    Sidebar
  },
  data () {
    return {
      nav: nav.items,
      loadingData: false
    }
  },
  computed: {
    user: function () {
      return this.$store.state.GET_USER_RESPONSE
    },
    needConsent () {
      return this.user.underAge === true && this.user.parentConsented === false
    },
    profileWarning: function () {
      /**
      inputVal.parentConsented === false
      inputVal.underAge === true
      */
      if (!this.user) {
        return null
      } else if (this.user.underAge === true && this.user.parentConsented === null) {
        // If user.parentalConcented == null the consent for has been uploaded but is under review
        return 'Microba is reviewing your consent form. No results will be displayed for any samples that have been supplied until the review process is complete.'
      } else if (this.user.underAge === true && this.user.parentConsented === false) {
        // If user.parentalConcented == false no consent form has been uploaded
        return 'Until the parent/guardian consent is completed and uploaded into My Profile we are unable to display any results.'
      } else {
        return null
      }
    }
  },
  methods: {
    attachUser () {
      if (!this.user) return

      /* eslint-disable */

      setTimeout(() => {
        FS.identify(this.user.id, {
          displayName: this.user.name,
          email: this.user.email
        })
      }, 2000)

      this.$intercom.boot({
        user_id: this.user.id,
        name: this.user.name,
        email: this.user.email,
      });
//      this.$intercom.show();


//    }
      /* eslint-enable */
    }
  },
  mounted () {
    this.attachUser()
  },
  watch: {
    user: function () {
      this.attachUser()
    }
  }
}
</script>

<style lang="scss">
  .sample-badge{
    /* mr-5 ml-3 my-auto px-4 py-1 h-25 */
    margin: auto 50px auto 20px;
    padding: 0.25rem 1.5rem;
    &__primary {
      background-color: #5e3f63;
    }
    &__secondary {
      background-color: #ff8708;
    }
    &-label {
        &__primary {
          font-size: 16px;
        }
        &__secondary {
          font-size: 16px;
        }
    }
  }
</style>

<style scoped lang="scss">
.page {
  /*padding-bottom: 100px;*/
}
.link {
  font-weight: bold;
  border-left: 1px solid rgba(255,255,255,0.7);
  padding: 0 1rem 0 2rem;
  margin-left: 2rem;
}
.alert.alert-warning{
  background: #3F9FCF;
  margin-bottom: 0px;
  color: white;
  a {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/templates/Page.vue